import {observer} from "mobx-react";
import { Controller } from "react-hook-form";
import {
    Button,
    FormControl,
    Grid,
    Grow,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    useMediaQuery,
    useTheme
} from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {accountStore} from "../../../Stores/AccountStore";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import * as React from "react";

const ShooterHandBlock = ({ register, control,  errors, submitForm, id, name, autoComplete, label, inputLabel, patternValue, patternMessage, requiredMessage, blockValue }) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('sm'));

    const handleBlocks = (event, name) => {
        let isActive = !active
        setActive(isActive)
        const eventButtonContent = event.target.innerText;
        if(!!eventButtonContent) {
            if (eventButtonContent.trim() === "GEM") {
                submitForm();
            }
        }
    };

    const [active, setActive] = React.useState(false);
    const ShootingHand = ["Højre", "Venstre", "Begge"];
    return (
        <Box>
            {active ?
                <Grow in={active}>
                    <Stack direction={{xs: 'column', sm: 'row'}} spacing={2} p={2} justifyContent="space-between"
                           alignItems="center">
                        <Controller
                            render={({ field }) => (
                                <FormControl fullWidth sx={{maxWidth: "100%"}}>
                                    <InputLabel id="favoriteHand">Skyttehånd</InputLabel>
                                    <Select labelId="favoriteHand" label="Skyttehånd" {...field}>
                                        <MenuItem value="right">Højre</MenuItem>
                                        <MenuItem value="left">Venstre</MenuItem>
                                        <MenuItem value="both">Begge</MenuItem>
                                    </Select>
                                </FormControl>
                            )}
                            control={control}
                            name="favoriteHand"/>
                        <Stack direction={{xs: 'row', sm: 'column'}} spacing={1}
                               width={matches ? "100%" : undefined} justifyContent="space-between"
                               alignItems="center">
                            <Button name={name + "Cancel"}
                                    variant="contained"
                                    onClick={(event) => handleBlocks(event, name)}
                                    fullWidth={!matches}
                                    color="jagtred">
                                Annuller
                            </Button>
                            <Button name={name + "Save"}
                                    onClick={(event) => handleBlocks(event, name)}
                                    fullWidth={!matches}
                                    variant="contained"
                                    color="jagtyellow">
                                Gem
                            </Button>
                        </Stack>
                    </Stack>
                </Grow>
                :
                matches ?
                    <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: "3em",
                        padding: 3
                    }}>
                        <Stack spacing={1}>
                            <Typography sx={{fontWeight: 'bold'}}> {label} </Typography>
                            <Typography id="shooterHandBlockText">{ShootingHand[accountStore.user.shootingHand]}</Typography>
                        </Stack>
                        <IconButton color="jagtred" name={name + "Edit"} onClick={(event) => handleBlocks(event, name)}> <EditIcon/>
                        </IconButton>
                    </Box>
                    :
                    <Grid container direction="row" justifyContent="space-around" alignItems="center" sx={{height: "5em", padding: 3}}>
                        <Grid item sm={3}>
                        <Typography sx={{fontWeight: 'bold'}}> {label} </Typography>
                        </Grid>
                        <Grid item sm={6}>
                            <Typography id="shooterHandBlockText">{ShootingHand[accountStore.user.shootingHand]}</Typography>
                        </Grid>
                        <Grid item sm={3} sx={{textAlign: "right"}}>
                        <IconButton color="jagtred" name={name + "Edit"}
                                    onClick={(event) => handleBlocks(event, name)}><EditIcon/></IconButton>
                        </Grid>
                    </Grid>
            }
        </Box>
    )

}

export default observer(ShooterHandBlock);